$('[data-scrollto]').on('click', function (e) {
    e.preventDefault();
    $("html, body").animate(
        { scrollTop: $($(this).attr('href')).offset().top - $(this).attr('data-scrollto') }
    );
    $($(this).attr('href')).find('[tabindex]').first().focus();
});